import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSupportAccount } from "./useSupportAccount";

export const useSupportWidget = (accountType?: "user" | "vendor") => {
  const [isOpen, setIsOpen] = useState(false);
  const { pathname } = useLocation();
  const account = useSupportAccount(accountType);
  const senderId = account?.senderId;
  const token = account?.token;
  const wasOpenRef = useRef(false);
  const controlsId =
    accountType === "vendor" ? "vendor-support-chat" : "customer-support-chat";

  useEffect(() => {
    const wasOpen = wasOpenRef.current;
    wasOpenRef.current = isOpen;
    if (wasOpen && !isOpen) document.getElementById(`${controlsId}-trigger`)?.focus();
  }, [controlsId, isOpen]);

  useEffect(() => {
    // Keep the intent until login has supplied both credentials for this account.
    if (!senderId || !token) return;
    try {
      const requested = localStorage.getItem("mbaay:customer-care:reopen-after-login") === "true" || localStorage.getItem("redirectToChat") === "true";
      if (!requested) return;
      localStorage.removeItem("mbaay:customer-care:reopen-after-login");
      localStorage.removeItem("redirectToChat");
    } catch {
      // Manual chat remains available if browser storage is disabled.
      return;
    }
    setIsOpen(true);
  }, [senderId, token, pathname]);

  const closeChat = useCallback(() => setIsOpen(false), []);
  const toggleChat = useCallback(() => setIsOpen((open) => !open), []);

  return { isOpen, closeChat, toggleChat };
};
